const $ = require("../utils/fetch");

export function getRoleList(name) {
  const params = {
    name: name,
  };
  name == "" ? delete params.name : "";
  return $.get("/role/list", params);
}

export function createRole(name, description, params) {
  params.name = name;
  params.description = description;
  description == "" ? delete params.description : "";
  //暂时去除key权限！！！
  // params.device.map(function (x) {
  //     delete x.permission.key
  // })

  return $.put("/role", params);
}

export function updateRole(roleId, name, description, params) {
  params.name = name;
  params.description = description;
  description == "" ? delete params.description : "";
  //暂时去除key权限！！！
  // params.device.map(function (x) {
  //     delete x.permission.key
  // })

  return $.post("/role/" + roleId, params);
}

export function getRoleById(roleId) {
  return $.get("/role/" + roleId, {});
}



// WEBPACK FOOTER //
// ./src/api/role.js